/**
 * Survey API Helper Functions
 * All survey-related API calls
 */

const API_BASE = process.env.REACT_APP_API || '';

/**
 * Create a new survey
 * POST /api/v1/surveys
 */
export const createSurvey = async (eventId, surveyData, token) => {
  const response = await fetch(`${API_BASE}surveys`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...surveyData,
      eventId,
    }),
  });
  const data = await response.json();
  return data;
};

/**
 * Get survey by event ID
 * GET /api/v1/surveys/event/:eventId
 */
export const getSurveyByEventId = async (eventId, token) => {
  const response = await fetch(`${API_BASE}surveys/event/${eventId}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Get survey by ID
 * GET /api/v1/surveys/:id
 */
export const getSurvey = async (id, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Update an existing survey
 * PATCH /api/v1/surveys/:id
 */
export const updateSurvey = async (id, payload, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}`, {
    method: 'PATCH',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  return data;
};

/**
 * Delete a survey
 * DELETE /api/v1/surveys/:id
 */
export const deleteSurvey = async (id, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Get survey QR code
 * GET /api/v1/surveys/:id/qrcode
 */
export const getSurveyQRCode = async (id, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}/qrcode`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Get survey responses
 * GET /api/v1/surveys/:id/responses
 */
export const getSurveyResponses = async (id, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}/responses`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Get survey analytics
 * GET /api/v1/surveys/:id/analytics
 */
export const getSurveyAnalytics = async (id, token) => {
  const response = await fetch(`${API_BASE}surveys/${id}/analytics`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Get public survey (for attendees)
 * GET /api/v1/surveys/public/:surveyId
 */
export const getPublicSurvey = async (surveyId) => {
  const response = await fetch(`${API_BASE}surveys/public/${surveyId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const data = await response.json();
  return data;
};

/**
 * Submit survey response (for attendees)
 * POST /api/v1/surveys/public/:surveyId/submit
 */
export const submitSurveyResponse = async (surveyId, payload) => {
  const response = await fetch(`${API_BASE}surveys/public/${surveyId}/submit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const data = await response.json();
  return data;
};
